import React from 'react'
import { StyledEngineProvider, Theme, ThemeProvider, responsiveFontSizes } from '@mui/material/styles'
import { StylesProvider } from '@mui/styles'
import { SupportTheme } from './theme'

declare module '@mui/styles/defaultTheme' {
  interface DefaultTheme extends Theme {}
}

export const SupportThemeProvider: React.FC = ({ children }) => {
  return (
    <StyledEngineProvider injectFirst>
      <StylesProvider injectFirst>
        <ThemeProvider theme={responsiveFontSizes(SupportTheme)}>{children}</ThemeProvider>
      </StylesProvider>
    </StyledEngineProvider>
  )
}

export default SupportThemeProvider
